export default __webpack_public_path__ + "static/media/multiply.14f1d9d1.png";